import { string } from 'prop-types';

import IconWithNotifications from '~/components/IconWithNotifications';

import usePurchasesIndicator from '~/redux/hooks/usePurchasesIndicator';

import { ReactComponent as CardsIcon } from '~/assets/images/iconsLibrary/cards.svg';

function InventoryIcon({ className }) {
  const unopenedPurchasesIndicator = usePurchasesIndicator();

  return (
    <IconWithNotifications
      showBadge={unopenedPurchasesIndicator}
      Svg={CardsIcon}
      className={className}
    />
  );
}

InventoryIcon.propTypes = {
  className: string,
};

export default InventoryIcon;
